const generateBg = (bonus) => {
  if (!bonus?.id)
    return 'linear-gradient(180deg, rgba(39, 38, 43, 0.00) 36.08%, #27262B 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), linear-gradient(0deg, #0FC 0%, #0FC 100%), #39202C;';

  const hue = (bonus.id * 137) % 360;

  const color1 = `hsl(${hue}, 70%, 60%)`;
  const color2 = `hsl(${hue + 60}, 80%, 30%)`;

  return `linear-gradient(180deg, rgba(39, 38, 43, 0.00) 36.08%, #27262B 100%), 
            linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), 
            linear-gradient(0deg, ${color1} 0%, ${color2} 100%), 
            #39202C`;
};

export { generateBg };
